module.exports = __webpack_public_path__ + "static/15-c12307e7fbecbcf3d526123f4b84a704.png";